import { ReactNode } from 'react'

type SimpleTableProps = {
  columns: { key: string; label: string; align?: 'end' | 'center' }[]
  children: ReactNode
}

/**
 * Table shell for short, non-paginated lists of ListRow rows (same look as ListingDetails tables). An "actions" column
 * has no visible header.
 */
export const SimpleTable = ({ columns, children }: SimpleTableProps) => (
  <div className="ph-table-wrap listing-table-wrapper">
    <table className="ph-table listing-table">
      <thead>
        <tr>
          {columns.map(column =>
            column.key === 'actions' ? (
              <th key={column.key} className="listing-actions-col">
                <span className="visually-hidden">{column.label}</span>
              </th>
            ) : (
              <th
                key={column.key}
                style={{ textAlign: column.align === 'end' ? 'right' : column.align === 'center' ? 'center' : 'left' }}
              >
                {column.label}
              </th>
            )
          )}
        </tr>
      </thead>
      <tbody>{children}</tbody>
    </table>
  </div>
)
